module.exports = __webpack_public_path__ + "61d85a0ae9d24debc8ec444690a1a2a1.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/td-icons.ttf
 ** module id = 27
 ** module chunks = 0
 **/